var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
    key: 0,
    class: "pre-order"
};
var _hoisted_2 = { class: "pre-order__wrap" };
var _hoisted_3 = { class: "pre-order__na" };
var _hoisted_4 = { class: "pre-order__text" };
var _hoisted_5 = { class: "pre-order__button" };
var _hoisted_6 = ["data-id", "data-type"];
import Message from "../../../components/Message.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'PreOrder',
    props: {
        available: { type: Boolean },
        type: { type: Object },
        productId: { type: Number, required: true },
    },
    setup: function (__props) {
        return function (_ctx, _cache) {
            var _a, _b, _c, _d, _e;
            return (!__props.available || ((_a = __props.type) === null || _a === void 0 ? void 0 : _a.disabled))
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createVNode(Message, {
                                strong: "",
                                icon: "cart-cross"
                            }, {
                                default: _withCtx(function () { return __spreadArray([], __read((_cache[0] || (_cache[0] = [
                                    _createTextVNode("Товара нет в наличии", -1 /* CACHED */)
                                ]))), false); }),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _cache[2] || (_cache[2] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_4, "Вы можете оформить предзаказ и мы свяжемся с вами,\n        когда " + _toDisplayString((_d = (_c = (_b = __props.type) === null || _b === void 0 ? void 0 : _b.name) === null || _c === void 0 ? void 0 : _c.toLocaleLowerCase('ru')) !== null && _d !== void 0 ? _d : 'товар') + " появится в наличии\n      ", 1 /* TEXT */),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn--1 btn--l btn--black win",
                                "data-act": "preorder",
                                "data-id": __props.productId,
                                "data-type": (_e = __props.type) === null || _e === void 0 ? void 0 : _e.id
                            }, __spreadArray([], __read((_cache[1] || (_cache[1] = [
                                _createElementVNode("span", { class: "btn__label" }, "Предзаказ", -1 /* CACHED */)
                            ]))), false), 8 /* PROPS */, _hoisted_6)
                        ])
                    ])
                ]))
                : _createCommentVNode("v-if", true);
        };
    }
});
